import { useEffect, useRef, useState, useMemo } from "react";

function useInView(options = {}) {
  const ref = useRef(null);
  const [isInView, setIsInView] = useState(false);

  // Memoize options to prevent unnecessary re-renders
  const memoizedOptions = useMemo(() => ({
    threshold: 0.1,
    rootMargin: '0px',
    ...options
  }), [
    options.threshold,
    options.root,
    options.rootMargin
  ]);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      console.log('useInView: No element to observe');
      return;
    }

    console.log('useInView: Setting up observer for element', element);
    console.log('useInView: Observer options', memoizedOptions);

    const observer = new IntersectionObserver(
      ([entry]) => {
        console.log('useInView: Intersection observed', {
          isIntersecting: entry.isIntersecting,
          intersectionRatio: entry.intersectionRatio,
          boundingClientRect: entry.boundingClientRect,
          target: entry.target
        });
        setIsInView(entry.isIntersecting);
      },
      memoizedOptions
    );

    observer.observe(element);

    // Capture the element in closure for cleanup
    return () => {
      console.log('useInView: Cleaning up observer');
      observer.unobserve(element);
      observer.disconnect();
    };
  }, [memoizedOptions]);

  return { ref, isInView };
}

export default useInView;